import { sidebarData } from "data";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import sloganImage from "./assets/images/slogan.png";
import styles from "./styles/style.module.scss";

const Sidebar = ({ sidebarCollapsed }) => {
    const [activeNav, setActiveNav] = useState(0);
    const { pathname } = useLocation();

    // TO SET ACTIVE NAV BASED ON THE PATHNAME
    useEffect(() => {
        setActiveNav(sidebarData.findIndex((item) => item.to === pathname));
    }, [pathname]);

    return (
        <div className={`${styles["main-sidebar"]}`}>
            <div className={`wrapper ${sidebarCollapsed ? "collapsed" : ""}`}>
                <div className="logo">
                    <div className="inner">
                        <Link to="/">
                            <div className="image-container">
                                <img
                                    src={sloganImage}
                                    alt=""
                                    className="logo-img"
                                />
                            </div>
                        </Link>
                    </div>
                </div>
                <div className="side-nav">
                    <div className="items-container">
                        {sidebarData?.map((item, index) => {
                            return (
                                <div className="link-item" key={item?.id}>
                                    <Link to={`${item?.to}`}>
                                        <button
                                            className={` ${
                                                activeNav === index
                                                    ? "active"
                                                    : ""
                                            }`}
                                        >
                                            <div className="overlay">
                                                <div className="icon">
                                                    {item?.svg}
                                                </div>
                                                <span className="">
                                                    <FormattedMessage
                                                        id={`${item?.text}`}
                                                    />
                                                </span>
                                            </div>
                                        </button>
                                    </Link>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
